"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.NodesFinder = void 0;
var nodeDef_1 = require("../../../../nodeDef");
var records_1 = require("../../../records");
var survey_1 = require("../../../../survey");
var utils_1 = require("../../../../utils");
var getCommonAncestor = function (params) {
    var _a;
    var record = params.record, nodeCtxHierarchy = params.nodeCtxHierarchy, nodeDefCtx = params.nodeDefCtx, nodeDefReferenced = params.nodeDefReferenced;
    if (!nodeDefCtx.parentUuid) {
        return records_1.Records.getRoot(record);
    }
    var nodeDefReferencedH = nodeDefReferenced.meta.h;
    var nodeDefCtxH = nodeDefCtx.meta.h;
    var nodeDefCommonH = utils_1.Arrays.intersection(nodeDefReferencedH, nodeDefCtxH);
    if (nodeDefCommonH.length === 1) {
        return records_1.Records.getRoot(record);
    }
    if (nodeDefCommonH.length > 1) {
        var nodeCommonAncestorUuid = nodeCtxHierarchy[nodeDefCommonH.length - 1];
        return (_a = record.nodes) === null || _a === void 0 ? void 0 : _a[nodeCommonAncestorUuid];
    }
    return undefined;
};
var getReferencedNodesParent = function (params) {
    var _a;
    var survey = params.survey, record = params.record, nodeContext = params.nodeContext, nodeDefReferenced = params.nodeDefReferenced;
    if (nodeDefReferenced.parentUuid === nodeContext.nodeDefUuid) {
        return nodeContext;
    }
    var nodeDefCtx = survey_1.Surveys.getNodeDefByUuid({ survey: survey, uuid: nodeContext.nodeDefUuid });
    var nodeCtxH = __spreadArray([], nodeContext.meta.h, true);
    if (nodeDefCtx.type === nodeDef_1.NodeDefType.entity) {
        nodeCtxH.push(nodeContext.uuid);
    }
    if (survey_1.Surveys.isNodeDefAncestor({ nodeDefAncestor: nodeDefReferenced, nodeDefDescendant: nodeDefCtx })) {
        var nodeDefReferencedH = nodeDefReferenced.meta.h;
        var nodeReferencedParentUuid = nodeCtxH[nodeDefReferencedH.length - 1];
        var nodeReferencedParent = (_a = record.nodes) === null || _a === void 0 ? void 0 : _a[nodeReferencedParentUuid];
        if (!nodeReferencedParent) {
            throw new Error("Cannot find parent node of ".concat(nodeDefReferenced.props.name, " from ").concat(nodeDefCtx.props.name));
        }
        return nodeReferencedParent;
    }
    var nodeCommonAncestor = getCommonAncestor({
        record: record,
        nodeCtxHierarchy: nodeCtxH,
        nodeDefCtx: nodeDefCtx,
        nodeDefReferenced: nodeDefReferenced
    });
    if (!nodeCommonAncestor) {
        return undefined;
    }
    return records_1.Records.getDescendant({ record: record, node: nodeCommonAncestor, nodeDefDescendant: nodeDefReferenced });
};
var findDescendants = function (params) {
    var survey = params.survey, record = params.record, nodeContext = params.nodeContext, nodeDefReferenced = params.nodeDefReferenced;
    var nodeReferencedParent = getReferencedNodesParent({ survey: survey, record: record, nodeContext: nodeContext, nodeDefReferenced: nodeDefReferenced });
    if (nodeReferencedParent) {
        return records_1.Records.getChildren({ record: record, parentNode: nodeReferencedParent, childDefUuid: nodeDefReferenced.uuid });
    }
    return [];
};
exports.NodesFinder = {
    findDescendants: findDescendants
};
//# sourceMappingURL=nodesFinder.js.map